import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import { replaceFrame } from 'rangeConfig/kallax/behaviors/replaceFrame';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import platform from 'rangeConfig/shared/utils/platform';

// Seems this file is needed, but it's currently not used since the Frames selected menu
// overrides this for the KALLAX Desks.
// It will however be used for the LAGKAPTEN+OLOV Desks when they're added.
//TODO: Add translation for the selectedMenu menuTitle & replace the current one once Lagkapten/Olov is added. (Current is placeholder to avoid console error message)

const desks = {
  id: 'desks-selected-menu',
  title: 'storageone.productListDesksTitle',
  cardSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceFrame],
    productDropped: [replaceFrame]
  },
  productTypes: [ProductType.KALLAX_DESK],
  productFilters: []
};

const widgets = {
  desktop: [desks],
  mobile: [desks]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.productListDesksTitle',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
